import React from 'react';
import './DonatePage.css';

export default function DonatePage() {
  return (
    <div className="donate-page">
      <div className="donate-panel">
        <header className="donate-header">
          <p className="donate-eyebrow">Support Vedanta Center of Charlotte</p>
          <h1>Make a Donation</h1>
          <p className="donate-intro">
            Your contribution helps sustain our programs, lectures, and community.
          </p>
        </header>

        <div className="donate-options">
          <section className="donate-card">
            <div className="donate-card-heading">
              <span className="donate-card-number">01</span>
              <h2>Zelle</h2>
            </div>
            <p className="donate-copy">
              Scan the QR code with your banking app to send your donation through Zelle.
            </p>
            <p className="donate-zelle-address">
              Zelle: <strong>vedantasoclt@gmail.com</strong>
            </p>
            <img
              className="donate-qr"
              src="/images/zelle-qr-vcc.jpeg"
              alt="Zelle donation QR code"
            />
          </section>

          <section className="donate-card">
            <div className="donate-card-heading">
              <span className="donate-card-number">02</span>
              <h2>PayPal</h2>
            </div>
            <p className="donate-copy">
              Donate securely online or scan the QR code with your phone.
            </p>
            <a
              href="https://paypal.com/us/fundraiser/charity/5165656"
              target="_blank"
              rel="noopener noreferrer"
              className="paypal-donate-btn"
            >
              Donate via PayPal
            </a>
            <img
              className="donate-qr donate-qr--paypal"
              src="/images/paypal-gofund-vcc.png"
              alt="PayPal donation QR code"
            />
          </section>
        </div>
      </div>
    </div>
  );
}
